// Generated from LogoEditor.g4 by ANTLR 4.5.2
// jshint ignore: start
var antlr4 = require('antlr4/index');
//MARTINA:
var damlev = require("../../../../node_modules/levenshtein-damerau/skodld.js");

var editor = new Array();
var variables = new Array();
var parameterNames = new Array();
var name;
var commands;

//MARTINA:
var currentLine;

//MARTINA:
//the text of the method currently being visited
var currentMethodText;

//MARTINA:
//the name of the method currently being visited
//var currentMethodName;
var currentMethodContext;

//MARTINA:
//the offset of the method currently being visited
var currentMethodOffset;

// MARTINA:
// methodCalls: collects all the method calls in the current method with the line number where they're in
// elements are like: {procedureInvocationContext, line number}
var methodCalls = new Array();

// MARTINA:
// every method has a number (first method: 0, second: 1, third: 2...)
var methodNumber;

// MARTINA:
// key: methodname, value: array of variables that exist in that method up to that point of the program
var methodVariables;

// MARTINA:
// collects errors during visiting. these errors are returned by this visitor and then displayed in the input component.
var errorsToDisplay;

//MARTINA:
//true iff there should be no deref check because PARAMSNOTOK or PARAMSNOCOLON
var noDerefCheck;

//MARTINA:
//false iff the body of the current method should not be visited because there's a problem with the method name
var visitMethodBody;

//MARTINA:
//true iff procedureDeclaration field nameEnd is true (so the name of the method is 'end')
var nameEnd;

//MARTINA:
//collects ends of the functions in order to find manyEnds
var end;

//MARTINA:
//true: should check methodcalls, false: should not check method calls, problem with method names
var checkMethodCalls;

//MARTINA:
//array of booleans, true: the last procedureInvocation could be a misspelled end, false: there cannot be a misspelled end
var maybeMisspelledEnd;

//MARTINA:
//booleans, true iff params were on a new line and error should be pushed at parameter declaration
var eolBeforeParams;

//MARTINA:
//boolean, true iff params were not all on the same line
var paramsOneLine;

//MARTINA:
//boolean, true iff the procInvoc. is similar to 'make', so there could be a string literal "gr allowed
var stringLiteralAllowed;

//MARTINA:
//boolean, true iff there was a string literal in the procedure invocation which is similar to 'make'
var maybeMake;

// This class defines a complete generic visitor for a parse tree produced by LogoEditorParser.

function LogoEditorVisitor(methodText, methodOffset) {
	antlr4.tree.ParseTreeVisitor.call(this);
	currentMethodText = methodText;
	currentMethodOffset = methodOffset+1;
	//methodNumber = 0;
	//methodCalls = new Array();

	return this;
}

LogoEditorVisitor.prototype = Object.create(antlr4.tree.ParseTreeVisitor.prototype);
LogoEditorVisitor.prototype.constructor = LogoEditorVisitor;


function visitChild(childnumber, ctx, ref) {
    var operationConstructorString = ctx.children[childnumber].constructor.toString().substr('function '.length);
    operationConstructorString = operationConstructorString.substr(0, operationConstructorString.indexOf('(') - 7);
    var operationName = "visit" + operationConstructorString;
    return ref[operationName](ctx.children[childnumber]);
}

// Visit a parse tree produced by LogoEditorParser#prog.
LogoEditorVisitor.prototype.visitProg = function (ctx) {
    //MARTINA
    methodCalls = new Array();
    methodVariables = new Array();
    errorsToDisplay = new Array();
    end = new Array();
    currentLine = currentMethodOffset;
    checkMethodCalls = true;
    maybeMisspelledEnd = new Array();
    methodNumber = 0;


    //MARTINA TRYOUT:
    editor = new Array();
    variables = new Array();
    //

    for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9, 8);
        if (text !== "Terminal") {
            visitChild(i, ctx, this);
        }
    }

    //MARTINA: added methodCallArray and errors
    var result = {edit: editor, param: variables, methodCallArray: methodCalls, errors: errorsToDisplay, doCheckMethodCalls: checkMethodCalls, maybeEnd: maybeMisspelledEnd};
    return result;//editor;

};


// Visit a parse tree produced by LogoEditorParser#line.
LogoEditorVisitor.prototype.visitLine = function (ctx) {
    //MARTINA
    var text = ctx.getText();
    var result = "";
    for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9, 8);
        if (text !== "Terminal") {
            var t = visitChild(i, ctx, this);
            result = result+ " " + t;
        }
    }
    commands = result;

};

LogoEditorVisitor.prototype.visitColornameWithoutTypingErrors = function(ctx) {

}


// Visit a parse tree produced by LogoEditorParser#cmd.
LogoEditorVisitor.prototype.visitCmd = function (ctx) {
    var allText = ctx.getText();
    var commandName = ctx.children[0].children[0].getText();

    //MARTINA:
    maybeMake = false;
    stringLiteralAllowed = false;
    //

    /* MARTINA INSERT NEW: */
    visitChild(0, ctx, this);
    /* END NEW*/

    return commandName + " " + allText.split(commandName)[1];
};


// Visit a parse tree produced by LogoEditorParser#procedureInvocation.
LogoEditorVisitor.prototype.visitProcedureInvocation = function(ctx) {

  //MARTINA
  if (checkMethodCalls){
  //MARTINA methodcallbugfix
    let defVars = new Array();
    defVars.push.apply(defVars,parameterNames);
    defVars.push.apply(defVars,methodVariables[name]);

    //check if it's similar to make in order to set stringLiteralAllowed
    //stringLiteral=true iff it could be a misspelled make (its similar to make)
    var longer;
    var shorter;
    var thisMethodName = ctx.children[0].getText();
      if (thisMethodName.length > "make".length){
        longer = thisMethodName;
        shorter = "make";
      }else{
        longer = "make";
        shorter = thisMethodName;
      }

      //calculate damerau levenshtein distance
      var damerauLevenshtein = damlev(longer,shorter);

    if (damerauLevenshtein <=2){
      stringLiteralAllowed = true;
    }else{
      stringLiteralAllowed = false;
    }

    //visit children
    for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9,8);
          if (text !== "Terminal") {
              visitChild(i, ctx, this);
          }
    }




    methodCalls[methodNumber].push({procedureInvocation: ctx, line: currentLine, definedVariables: defVars, maybeMisspelledMake: maybeMake});
  }
  //visit children
  for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9,8);
          if (text !== "Terminal") {
              visitChild(i, ctx, this);
          }

  }
};

// Visit a parse tree produced by LogoEditorParser#procedureDeclaration.
LogoEditorVisitor.prototype.visitCorrectProcedureDeclaration = function (ctx) {
  
}


// Visit a parse tree produced by LogoEditorParser#procedureDeclaration.
LogoEditorVisitor.prototype.visitProcedureDeclaration = function (ctx) {
    // MARTINA
    // first we check for errors in the procedureDeclaration:

    methodNumber = methodNumber + 1;
    visitMethodBody = true;
    noDerefCheck = false;
    nameEnd = false;
    eolBeforeParams = false;
    paramsOneLine = false;
    maybeMisspelledEnd[methodNumber] = false;
    currentMethodContext = ctx;
    //MARTINA methodcallbugfix

    if (!(ctx.MANYTOS == null)){
      // there are several TOs at the beginning of the procedureDeclaration

      errorsToDisplay.push({line: currentLine, msg: "manyTos"});
      checkMethodCalls = false;
      noDerefCheck = true;

    }else if (!(ctx.EOLAFTERTO == null)){
      // there is an EOL after 'to'
      errorsToDisplay.push({line: currentLine, msg: "eolAfterTo"});
      checkMethodCalls = false;
      noDerefCheck = true;

    }else if (!(ctx.NAMETO == null)){
      // the procedure name is 'to'

      errorsToDisplay.push({line: currentLine, msg: "nameTO"});
      visitMethodBody = false;
      name = "to";
      end[name] = 0;
      checkMethodCalls = false;
      noDerefCheck = true;

    }else if (!(ctx.NAMEEND == null)){
      // the procedure name is 'end'
      nameEnd = true;
      errorsToDisplay.push({line: currentLine, msg: "nameEND"});
      visitMethodBody = false;
      name = "end";
      end[name] = 0;
      checkMethodCalls = false;
      noDerefCheck = true;

    }else if (!(ctx.NAMECMD == null)){
      // the procedure name is a cmd

      errorsToDisplay.push({line: currentLine, msg: "nameCMD"});
      visitMethodBody = false;
      name = "something";
      end[name] = 0;
      checkMethodCalls = false;
      noDerefCheck = true;

    }else if (!(ctx.NAMEFUNC == null)){
      // the procedure name is a function

      errorsToDisplay.push({line: currentLine, msg: "nameFUNC"});
      visitMethodBody = false;
      name = "something";
      end[name] = 0;
      checkMethodCalls = false;
      noDerefCheck = true;

    }else if (!(ctx.NONAME == null)){
      // there is no procedure name


      errorsToDisplay.push({line: currentLine, msg: "noName"});
      visitMethodBody = false;
      name = "something";
      end[name] = 0;
      checkMethodCalls = false;
      noDerefCheck = true;

    }else if (!(ctx.PARAMSNOCOLON == null)){
      // the parameters have no colons
      noDerefCheck = true;
      errorsToDisplay.push({line: currentLine, msg: "paramsNoColon"});
      checkMethodCalls = false;

    }else if (!(ctx.METHODNAMEWHITESPACE == null)){
      // there are whitespaces in the method name

      noDerefCheck = true;
      errorsToDisplay.push({line: currentLine, msg: "methodNameWhitespace"});
      errorsToDisplay.push({line: currentLine, msg: "paramsNoColon"});
      checkMethodCalls = false;
      visitMethodBody = false;
      name = "something";
      end[name] = 0;

    }else if (!(ctx.NOEOL == null)){
      // no EOL after method name / parameter declarations
      errorsToDisplay.push({line: currentLine, msg: "noEOL"});

    }else if (!(ctx.NOEOLBEFOREEND == null)){
      // no EOL before 'end'
      // find out line to show red cross on
      var textUntilEnd = currentMethodText.substr(0,currentMethodText.indexOf("end"));
      var endOffset = textUntilEnd.split(/\r\n|\r|\n/).length - 1;

      errorsToDisplay.push({line: currentLine+endOffset, msg: "noEOLbeforeEND"});

    }else if (!(ctx.MISSINGTO == null)){
      // there is no 'to'
      errorsToDisplay.push({line: currentLine, msg: "missingTo"});
      noDerefCheck = true;

    }else if (!(ctx.NOTONONAME == null)){
      // the method starts with a parameterDeclaration

      visitMethodBody = false;
      name = "something";
      end[name] = 0;
      errorsToDisplay.push({line: currentLine, msg: "noToNoName"});
      checkMethodCalls = false;

    }else if (!(ctx.NOTONONAMETOO == null)){
      // the method starts with a command

      visitMethodBody = false;
      name = "something";
      end[name] = 0;
      errorsToDisplay.push({line: currentLine, msg: "noToNoName"});
      checkMethodCalls = false;

    }else if (!(ctx.EOLBEFOREPARAMS == null)){
      // the parameters are on a new line

      //set boolean in order to push error at parameter declaration
      eolBeforeParams = true;
      checkMethodCalls = false;
      noDerefCheck = true;

    }else if (!(ctx.PARAMSONELINE == null)){
      //the parameters are not all on one line
      paramsOneLine = true;
      checkMethodCalls = false;
      noDerefCheck = true;
    }

    if (visitMethodBody){
        // there is no problem with the method name
        //get the method name
        for (var i = 0; i < ctx.children.length; i++) {
          var text = ctx.children[i].constructor.toString().substr(9,4);
          if (text === "Name") {
              visitChild(i, ctx, this);
              break;
          }
      }

      end[name] = 0;

      if (!(editor[name] == null)){
        // the method was already declared
        errorsToDisplay.push({line: currentLine, msg: "doubleDeclaration"});

        checkMethodCalls = false;
      }

      methodCalls[methodNumber] = new Array();
      parameterNames = new Array();
      methodVariables[name] = new Array();

        //just visit all children
        for (var i = 0; i < ctx.children.length; i++) {
            var text = ctx.children[i].constructor.toString().substr(9,8);
            if (text !== "Terminal") {
                visitChild(i, ctx, this);
            }
        }


      editor[name] = ctx;//TODO Jacqueline: commands;
      variables[name] = parameterNames;
    
    }else{
      // there is a problem with the method name

        parameterNames = new Array();
        methodVariables[name] = new Array();


        for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9,8);
          if (text !== "Terminal") {
              visitChild(i, ctx, this);
          }
        }


    }

    if ((end[name] === 0) || ((end[name] === 1)&&nameEnd)){
      // there is no end

      maybeMisspelledEnd[methodNumber] = checkLastProcedureInvocation(ctx);

      if (maybeMisspelledEnd[methodNumber] == false){
        errorsToDisplay.push({line: currentLine, msg: "missingEnd"});
      }
    }
};

//MARTINA
//returns true iff the last procedure invocation could be a misspelled end, meaning, it's at the end
checkLastProcedureInvocation = function (context) {

  var lines = new Array();

  //we get a list of all the lines of the procedure declaration
  for (let c of context.children){
    var text = c.constructor.toString().substr(9, 4);
    if (text === "Line"){
      lines.push(c);
    }
  }

  var k;
  //see if the last thing in the procedure declaration is a procedure invocation
  for (k = lines.length-1; k>=0; k--){
    let numberOfChildren = lines[k].children.length;
    if (numberOfChildren>0){
      text = lines[k].children[numberOfChildren-1].constructor.toString().substr(9, 7);
      if (text === "Comment"){
        if (numberOfChildren>1){
          //see if the thing before the comment is a cmd
          text = lines[k].children[numberOfChildren-2].constructor.toString().substr(9, 3);
          if (text === "Cmd"){
            //see if it's a procedure invocation
            let cmdChild = lines[k].children[numberOfChildren-2].children[0];
            text = cmdChild.constructor.toString().substr(9, 19);
            if (text === "ProcedureInvocation"){
              return true;
            }else{
              return false;
            }
          }
        }
      }else if (text.startsWith("Cmd")){
        //see if it's a procedure invocation
        let cmdChild = lines[k].children[numberOfChildren-1].children[0];
            text = cmdChild.constructor.toString().substr(9, 19);
            if (text === "ProcedureInvocation"){
              return true;
            }else{
              return false;
            }
      }
    }
  }
  return false;
};

// Visit a parse tree produced by LogoEditorParser#parameterDeclarations.
LogoEditorVisitor.prototype.visitParameterDeclarations = function (ctx) {
    //MARTINA
    if (eolBeforeParams){
      // there was an eol before (or between) the parameter declarations
      errorsToDisplay.push({line: currentLine, msg: "eolBeforeParams"});
    }else if (paramsOneLine){
      // the parameters were not all on the same line
      errorsToDisplay.push({line: currentLine, msg: "paramsOneLine"});
    }

    if (!(ctx.PARAMDECLNOTOK == null)){
      // there is a space between the : and the name in the parameter declaration
      noDerefCheck = true;
      errorsToDisplay.push({line: currentLine, msg: "paramDeclsNotOk"});

    }else if (!(ctx.PARAMDECLNONAME == null)){
      // there is a colon without a parameter name afterwards
      noDerefCheck = true;
      errorsToDisplay.push({line: currentLine, msg: "paramDeclNoName"});

    }else{
    // OLD VERSION: var param = ctx.children[1].getText();

    // MARTINA NEW VERSION (2 Linien):
    var param = ctx.children[0].getText();
    param = param.substr(1);

    //MARTINA NEW:
    if (parameterNames.indexOf(param) !== -1){
      errorsToDisplay.push({line: currentLine, msg: "sameParam"+param});
    }else{

    // geh�rt noch zu OLD VERSION:
    parameterNames.push(param);

    //MARTINA NEW: }
    }
    /* OLD VERSION:
    if(ctx.children.length > 2){
        visitChild(2, ctx, this);
    }*/
    }
};


// Visit a parse tree produced by LogoEditorParser#func.
LogoEditorVisitor.prototype.visitFunc = function(ctx) {
  // MARTINA: visit all children (this function was empty before)

  for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9,8);
        if (text !== "Terminal") {
            visitChild(i, ctx, this);
        }
  }

};


// Visit a parse tree produced by LogoEditorParser#repeat.
LogoEditorVisitor.prototype.visitRepeat = function(ctx) {
  //MARTINA
  if (!(ctx.REPEATMISSINGEXPR == null)){
    // there was no expression between repeat and block

    errorsToDisplay.push({line: currentLine, msg: "repeatMissingExpr"});


  }else if (!(ctx.REPEATMISSINGBLOCK == null)){
    // there was no block after repeat and expression

    errorsToDisplay.push({line: currentLine, msg: "repeatMissingBlock"});

  }else if (!(ctx.REPEATNOARG == null)){
    // there is no argument for repeat

    errorsToDisplay.push({line: currentLine, msg: "repeatNoArg"});

  }else if (!(ctx.REPEATNOBRACKETS == null)){
    // there are no brackets around the command(s)

    errorsToDisplay.push({line: currentLine, msg: "repeatNoBrackets"});

  }else if (!(ctx.REPEATMANYBLOCKS == null)){
    // there are too many blocks

    errorsToDisplay.push({line: currentLine, msg: "repeatManyBlocks"});

  }

  //MARTINA: visit arguments
  for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9,8);
        if (text !== "Terminal") {
            visitChild(i, ctx, this);
        }
  }
};


// Visit a parse tree produced by LogoEditorParser#whilee.
LogoEditorVisitor.prototype.visitWhilee = function(ctx) {

  //MARTINA
  if (!(ctx.WHILEMISSINGRIGHTPAREN == null)){
    // the right parenthesis around the expression is missing
    errorsToDisplay.push({line: currentLine, msg: "whileMissingRightParen"});


  }else if (!(ctx.WHILEMISSINGLEFTPAREN == null)){
    // the left parenthesis around the expression is missing
    errorsToDisplay.push({line: currentLine, msg: "whileMissingLeftParen"});


  }else if (!(ctx.WHILEMISSINGBOTHPAREN == null)){
    // both parentheses around the expression are missing
    errorsToDisplay.push({line: currentLine, msg: "whileMissingBothParen"});


  }else if (!(ctx.WHILEWRONGRIGHTPAREN == null)){
    // the right parenthesis around the expression is wrong

    errorsToDisplay.push({line: currentLine, msg: "whileWrongRightParen"});


  }else if (!(ctx.WHILEWRONGLEFTPAREN == null)){
    // the left parenthesis around the expression is wrong
    errorsToDisplay.push({line: currentLine, msg: "whileWrongLeftParen"});


  }else if (!(ctx.WHILEWRONGBOTHPAREN == null)){
    // both parentheses around the expression are wrong
    errorsToDisplay.push({line: currentLine, msg: "whileWrongBothParen"});


  }else if (!(ctx.WHILEMISSINGBLOCK == null)){
    // the block is missing
    errorsToDisplay.push({line: currentLine, msg: "whileMissingBlock"});


  }else if (!(ctx.WHILEMANYBLOCKS == null)){
    // there are too many blocks
    errorsToDisplay.push({line: currentLine, msg: "whileManyBlocks"});


  }else if (!(ctx.WHILENOARGS == null)){
    // there are no arguments to while
    errorsToDisplay.push({line: currentLine, msg: "whileNoArgs"});
  }

  //MARTINA: visit expression and visit block
  for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9,8);
        if (text !== "Terminal") {
            visitChild(i, ctx, this);
        }
  }
};


// Visit a parse tree produced by LogoEditorParser#ife.
LogoEditorVisitor.prototype.visitIfe = function(ctx) {

  //MARTINA
  if (!(ctx.IFNOBLOCK == null)){
    // there is no block
    errorsToDisplay.push({line: currentLine, msg: "ifNoBlock"});

  }else if (!(ctx.IFMANYBLOCKS == null)){
    // there are too many blocks
    errorsToDisplay.push({line: currentLine, msg: "ifManyBlocks"});

  }else if (!(ctx.IFBRACKETS == null)){
    // there are brackets
    errorsToDisplay.push({line: currentLine, msg: "ifBrackets"});

  }else if (!(ctx.IFNOARGS == null)){
    // there are no arguments to if
    errorsToDisplay.push({line: currentLine, msg: "ifNoArgs"});
  }

  //MARTINA: visit expression and visit block(s)
  for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9,8);
        if (text !== "Terminal") {
            visitChild(i, ctx, this);
        }
  }
};


// Visit a parse tree produced by LogoEditorParser#expression.
LogoEditorVisitor.prototype.visitExpression = function(ctx) {
  // MARTINA: visit all children (this function was empty before)

  for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9,8);
        if (text !== "Terminal") {
            visitChild(i, ctx, this);
        }
  }

};


// Visit a parse tree produced by LogoEditorParser#comparisonOperator.
LogoEditorVisitor.prototype.visitComparisonOperator = function(ctx) {
  // MARTINA: Visit children 
  for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9,8);
        if (text !== "Terminal") {
            visitChild(i, ctx, this);
        }
  }

};


// Visit a parse tree produced by LogoEditorParser#sExpr.
LogoEditorVisitor.prototype.visitSExpr = function(ctx) {
  // MARTINA: visit all children (this function was empty before)

  for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9,8);
        if (text !== "Terminal") {
            visitChild(i, ctx, this);
        }
  }
};


// Visit a parse tree produced by LogoEditorParser#term.
LogoEditorVisitor.prototype.visitTerm = function(ctx) {
  // MARTINA: visit all children (this function was empty before)

  for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9,8);
        if (text !== "Terminal") {
            visitChild(i, ctx, this);
        }
  }
};


// Visit a parse tree produced by LogoEditorParser#factor.
LogoEditorVisitor.prototype.visitFactor = function(ctx) {
  // MARTINA: visit all children (this function was empty before)

  for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9,8);
        if (text !== "Terminal") {
            visitChild(i, ctx, this);
        }
  }
};


// Visit a parse tree produced by LogoEditorParser#nsFact.
LogoEditorVisitor.prototype.visitNsFact = function(ctx) {
  // MARTINA: visit all children (this function was empty before)

  for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9,8);
        if (text !== "Terminal") {
            visitChild(i, ctx, this);
        }
  }
};


// Visit a parse tree produced by LogoEditorParser#value.
LogoEditorVisitor.prototype.visitValue = function(ctx) {
  // MARTINA: visit all children (this function was empty before)

  for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9,8);
        if (text !== "Terminal") {
            visitChild(i, ctx, this);
        }
  }
};


// Visit a parse tree produced by LogoEditorParser#deref.
LogoEditorVisitor.prototype.visitDeref = function(ctx) {
  var derefSpace = false;
  //MARTINA
  if (noDerefCheck){
    // do nothing, don't check deref
  }else{
    if (!(ctx.DEREFNONAME == null)){
    //there was no name after the :
    errorsToDisplay.push({line: currentLine, msg: "paramDeclNoName"});

    }else{

    if (!(ctx.DEREFNOTOK == null)){
      // there is a space between : and name

      errorsToDisplay.push({line: currentLine, msg: "derefNotOk"});
      derefSpace = true;

    }else if (!(ctx.DEREFMAKEONE == null) || !(ctx.DEREFMAKETWO == null)){
      // the child did "gr instead of :gr

      //let's check if it misspelled 'make'

      if (stringLiteralAllowed){
        maybeMake = true;
        return;
      }else{
        errorsToDisplay.push({line: currentLine, msg: "derefMake"});
        return;
      }
    }

    //get variable name

    var derefVariableName;
    if (derefSpace){
      derefVariableName = ctx.children[1].getText();
    }else{
      derefVariableName = ctx.children[0].getText().substr(1);
    }

    //MARTINA: we need to check if the variable we are trying to access exists
    //OLD if (parameterNames.indexOf(derefVariableName) === -1 && methodVariables[name][derefVariableName] == null){
    if (parameterNames.indexOf(derefVariableName) === -1 && methodVariables[name].indexOf(derefVariableName) === -1){
      //the variable we are trying to access doesn't exist
      errorsToDisplay.push({line: currentLine, msg: "variableNotDeclared"+derefVariableName});

      //see if there is a similar variable name
      var existingParams = new Array();
      existingParams.push.apply(existingParams,parameterNames);
      existingParams.push.apply(existingParams,methodVariables[name]);
      var similar = new Array();
      var longer;
      var shorter;
      for (let p of existingParams){
        if (derefVariableName.length > p.length){
          longer = derefVariableName;
          shorter = p;
        }else{
          longer = p;
          shorter = derefVariableName;
        }

        //calculate damerau levenshtein distance
        var damerauLevenshtein = damlev(longer,shorter);

        if (damerauLevenshtein<=p.length/2){
          similar.push(p);
        }
      }

      for (var i=0; i<similar.length; i++){
        errorsToDisplay.push({line: currentLine, msg: "didYouMean"+":"+similar[i]});
      }

    }
  }
  }
};


// Visit a parse tree produced by LogoEditorParser#colornumber.
LogoEditorVisitor.prototype.visitColornumber = function(ctx) {
  //MARTINA: visit expression
  this.visitExpression(ctx.children[0]);

};


// Visit a parse tree produced by LogoEditorParser#make.
LogoEditorVisitor.prototype.visitMake = function(ctx) {
  //MARTINA

  if (!(ctx.MAKELITNOTOK == null)){
      // there is a space between the " and the name in the string literal
      errorsToDisplay.push({line: currentLine, msg: "makeLitNotOk"});
      noDerefCheck = true;
      this.visitValue(ctx.children[3]);

  }else if (!(ctx.MAKEMANYVALS == null)){
    // there are too many values
    errorsToDisplay.push({line: currentLine, msg: "makeManyVals"});
    noDerefCheck = true;
    //todo: maybe visit values

    //find out what is too much
      var tooMuch = "";
      for (var i=3; i<ctx.children.length; i++){
        tooMuch = tooMuch+getTooMuch(ctx.children[i]);
      }

      errorsToDisplay.push({line: currentLine, msg: "tooMuch"+tooMuch});

  }else if (!(ctx.MAKENOVAL == null)){
    // there is no value
    errorsToDisplay.push({line: currentLine, msg: "makeNoVal"});
    noDerefCheck = true;

  }else if (!(ctx.MAKENOLIT == null)){
    // there was no string literal
    errorsToDisplay.push({line: currentLine, msg: "makeNoLit"});

  }else if (!(ctx.MAKEREVERSE == null)){
    // it was of the form ' make 5 "g '
    errorsToDisplay.push({line: currentLine, msg: "makeReverse"});

  }else if (!(ctx.MAKECOLON == null)){
    // it was of the form ' make :g 5 '
    errorsToDisplay.push({line: currentLine, msg: "makeColon"});
    noDerefCheck = true;

  }else if (!(ctx.MAKESPACEMANYVALS == null)){
    // there is a space in the string literal and there are too many values
    errorsToDisplay.push({line: currentLine, msg: "makeLitNotOk"});
    errorsToDisplay.push({line: currentLine, msg: "makeManyVals"});
    noDerefCheck = true;
    //todo: maybe visit values

    //find out what is too much
      var tooMuch = "";
      for (var i=4; i<ctx.children.length; i++){
        tooMuch = tooMuch+getTooMuch(ctx.children[i]);
      }

      errorsToDisplay.push({line: currentLine, msg: "tooMuch"+tooMuch});

  }else if (!(ctx.MAKESPACENOVAL == null)){
    // there is a space in the string literal and there is no value
    errorsToDisplay.push({line: currentLine, msg: "makeLitNotOk"});
    errorsToDisplay.push({line: currentLine, msg: "makeNoVal"});
    noDerefCheck = true;

  }else if (!(ctx.MAKENOARGS == null)){
    // there are no arguments to 'make'
    errorsToDisplay.push({line: currentLine, msg: "makeNoArgs"});

  }else{

  //MARTINA: visit value
  this.visitValue(ctx.children[2]);

  //get variable name
  var variableName = ctx.children[1].getText().substr(1);

  //everything's okay, add the variable to methodVariables[currentMethodName]
  //OLD methodVariables[name][variableName] = true;
  //NEW:
  methodVariables[name].push(variableName);
  }

};


// Visit a parse tree produced by LogoEditorParser#print.
LogoEditorVisitor.prototype.visitPrint = function(ctx) {
  //MARTINA

  if (!(ctx.PRINTNOARG == null)){
    // there is no argument
    errorsToDisplay.push({line: currentLine, msg: "printNoArg"});

    //throw ({line: currentLine, msg: "printNoArg"});

  }else if (!(ctx.PRINTMANYARGS == null)){
    // there are too many arguments
    errorsToDisplay.push({line: currentLine, msg: "printManyArgs"});

    //find out what is too much
      var tooMuch = "";
      for (var i=2; i<ctx.children.length; i++){
        tooMuch = tooMuch+getTooMuch(ctx.children[i]);
      }

      errorsToDisplay.push({line: currentLine, msg: "tooMuch"+tooMuch});
  }

  //MARTINA TODO: visit expressions?
  for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9,8);
        if (text !== "Terminal") {
            visitChild(i, ctx, this);
        }
  }

};


// Visit a parse tree produced by LogoEditorParser#quotedstring.
LogoEditorVisitor.prototype.visitQuotedstring = function(ctx) {
  //MARTINA
  if (!(ctx.QUOTEDSTRINGWRONGBRACKETS == null)){
    // () instead of []
    errorsToDisplay.push({line: currentLine, msg: "quotedstringWrongBrackets"});

  }else if (!(ctx.QUOTEDSTRINGWRONGLEFTBR == null)){
    // wrong left bracket
    errorsToDisplay.push({line: currentLine, msg: "quotedstringWrongLeftBr"});

  }else if (!(ctx.QUOTEDSTRINGWRONGRIGHTBR == null)){
    // wrong right bracket

    errorsToDisplay.push({line: currentLine, msg: "quotedstringWrongRightBr"});

  }else if (!(ctx.QUOTEDSTRINGMISSINGRIGHTBR == null)){
    // right bracket is missing
    errorsToDisplay.push({line: currentLine, msg: "quotedstringMissingRightBr"});

  }

  //MARTINA: visit children
  for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9,8);
        if (text !== "Terminal") {
            visitChild(i, ctx, this);
        }
  }
};


// Visit a parse tree produced by LogoEditorParser#name.
LogoEditorVisitor.prototype.visitName = function (ctx) {
    name = ctx.getText();
};

//MARTINA
getTooMuch = function(ctx){
        //get children text
        var text = ctx.constructor.toString().substr(9,8);
        if (text !== "Terminal") {
            var temp = "";
            for (var i=0; i<ctx.children.length; i++){
              temp = temp+getTooMuch(ctx.children[i]);
            }
            return temp;
        }else{
            return ctx.getText()+" ";
        }
}


//MARTINA
// Visit a parse tree produced by LogoEditorParser#fd.
LogoEditorVisitor.prototype.visitFd = function(ctx) {

  if (!(ctx.FDMANYARGS == null)){
      // there are too many arguments for fd
      errorsToDisplay.push({line: currentLine, msg: "fdManyArgs"});

      //find out what is too much
      var tooMuch = "";
      for (var i=2; i<ctx.children.length; i++){
        tooMuch = tooMuch+getTooMuch(ctx.children[i]);
      }

      errorsToDisplay.push({line: currentLine, msg: "tooMuch"+tooMuch});

  }else if (!(ctx.FDNOARGS == null)){
      // there are no arguments for fd
      errorsToDisplay.push({line: currentLine, msg: "fdNoArgs"});

  }

  // visit expression(s)
  for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9,8);
        if (text !== "Terminal") {
            visitChild(i, ctx, this);
        }
  }

};


// Visit a parse tree produced by LogoEditorParser#bk.
LogoEditorVisitor.prototype.visitBk = function(ctx) {
  //MARTINA
  if (!(ctx.BKMANYARGS == null)){
      // there are too many arguments for bk
      errorsToDisplay.push({line: currentLine, msg: "bkManyArgs"});

      //find out what is too much
      var tooMuch = "";
      for (var i=2; i<ctx.children.length; i++){
        tooMuch = tooMuch+getTooMuch(ctx.children[i]);
      }

      errorsToDisplay.push({line: currentLine, msg: "tooMuch"+tooMuch});

  }else if (!(ctx.BKNOARGS == null)){
      // there are no arguments for bk

      errorsToDisplay.push({line: currentLine, msg: "bkNoArgs"});

  }

  //MARTINA: visit expression
  // visit expression(s)
  for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9,8);
        if (text !== "Terminal") {
            visitChild(i, ctx, this);
        }
  }
};


// Visit a parse tree produced by LogoEditorParser#rt.
LogoEditorVisitor.prototype.visitRt = function(ctx) {
  //MARTINA

  if (!(ctx.RTMANYARGS == null)){
      // there are too many arguments for rt
      errorsToDisplay.push({line: currentLine, msg: "rtManyArgs"});

      //find out what is too much
      var tooMuch = "";
      for (var i=2; i<ctx.children.length; i++){
        tooMuch = tooMuch+getTooMuch(ctx.children[i]);
      }

      errorsToDisplay.push({line: currentLine, msg: "tooMuch"+tooMuch});

  }else if (!(ctx.RTNOARGS == null)){
      // there are no arguments for rt
      errorsToDisplay.push({line: currentLine, msg: "rtNoArgs"});
  }

  // visit expression(s)
  for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9,8);
        if (text !== "Terminal") {
            visitChild(i, ctx, this);
        }
  }
};


// Visit a parse tree produced by LogoEditorParser#lt.
LogoEditorVisitor.prototype.visitLt = function(ctx) {
  //MARTINA
  if (!(ctx.LTMANYARGS == null)){
      // there are too many arguments for lt

      errorsToDisplay.push({line: currentLine, msg: "ltManyArgs"});

      //find out what is too much
      var tooMuch = "";
      for (var i=2; i<ctx.children.length; i++){
        tooMuch = tooMuch+getTooMuch(ctx.children[i]);
      }

      errorsToDisplay.push({line: currentLine, msg: "tooMuch"+tooMuch});

  }else if (!(ctx.LTNOARGS == null)){
      // there are no arguments for lt

      errorsToDisplay.push({line: currentLine, msg: "ltNoArgs"});

  }
  //MARTINA: visit expression
  // visit expression(s)
  for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9,8);
        if (text !== "Terminal") {
            visitChild(i, ctx, this);
        }
  }
};


// Visit a parse tree produced by LogoEditorParser#cs.
LogoEditorVisitor.prototype.visitCs = function(ctx) {
  //MARTINA
  if (!(ctx.CSMANYARGS == null)){
      // there are too many arguments for cs

      errorsToDisplay.push({line: currentLine, msg: "csManyArgs"});

      //find out what is too much
      var tooMuch = "";
      for (var i=1; i<ctx.children.length; i++){
        tooMuch = tooMuch+getTooMuch(ctx.children[i]);
      }

      errorsToDisplay.push({line: currentLine, msg: "tooMuch"+tooMuch});

  }
};

// Visit a parse tree produced by LogoEditorParser#ct.
LogoEditorVisitor.prototype.visitCt = function(ctx) {
  //MARTINA
  if (!(ctx.CTMANYARGS == null)){
      // there are too many arguments for ct

      errorsToDisplay.push({line: currentLine, msg: "ctManyArgs"});

      //find out what is too much
      var tooMuch = "";
      for (var i=1; i<ctx.children.length; i++){
        tooMuch = tooMuch+getTooMuch(ctx.children[i]);
      }

      errorsToDisplay.push({line: currentLine, msg: "tooMuch"+tooMuch});

  }
};


// Visit a parse tree produced by LogoEditorParser#pu.
LogoEditorVisitor.prototype.visitPu = function(ctx) {
  //MARTINA
if (!(ctx.PUMANYARGS == null)){
      // there are too many arguments for pu

      errorsToDisplay.push({line: currentLine, msg: "puManyArgs"});

      //find out what is too much
      var tooMuch = "";
      for (var i=1; i<ctx.children.length; i++){
        tooMuch = tooMuch+getTooMuch(ctx.children[i]);
      }

      errorsToDisplay.push({line: currentLine, msg: "tooMuch"+tooMuch});

  }
};


// Visit a parse tree produced by LogoEditorParser#pd.
LogoEditorVisitor.prototype.visitPd = function(ctx) {
  //MARTINA
  if (!(ctx.PDMANYARGS == null)){
      // there are too many arguments for pd

      errorsToDisplay.push({line: currentLine, msg: "pdManyArgs"});

      //find out what is too much
      var tooMuch = "";
      for (var i=1; i<ctx.children.length; i++){
        tooMuch = tooMuch+getTooMuch(ctx.children[i]);
      }

      errorsToDisplay.push({line: currentLine, msg: "tooMuch"+tooMuch});

  }
};


// Visit a parse tree produced by LogoEditorParser#pe.
LogoEditorVisitor.prototype.visitPe = function(ctx) {
  //MARTINA
  if (!(ctx.PEMANYARGS == null)){
      // there are too many arguments for pe

      errorsToDisplay.push({line: currentLine, msg: "peManyArgs"});

      //find out what is too much
      var tooMuch = "";
      for (var i=1; i<ctx.children.length; i++){
        tooMuch = tooMuch+getTooMuch(ctx.children[i]);
      }

      errorsToDisplay.push({line: currentLine, msg: "tooMuch"+tooMuch});

  }
};


// Visit a parse tree produced by LogoEditorParser#ppt.
LogoEditorVisitor.prototype.visitPpt = function(ctx) {
  //MARTINA
  if (!(ctx.PPTMANYARGS == null)){
      // there are too many arguments for ppt

      errorsToDisplay.push({line: currentLine, msg: "pptManyArgs"});

      //find out what is too much
      var tooMuch = "";
      for (var i=1; i<ctx.children.length; i++){
        tooMuch = tooMuch+getTooMuch(ctx.children[i]);
      }

      errorsToDisplay.push({line: currentLine, msg: "tooMuch"+tooMuch});

  }
};


// Visit a parse tree produced by LogoEditorParser#ht.
LogoEditorVisitor.prototype.visitHt = function(ctx) {
  //MARTINA
  if (!(ctx.HTMANYARGS == null)){
      // there are too many arguments for ht

      errorsToDisplay.push({line: currentLine, msg: "htManyArgs"});

      //find out what is too much
      var tooMuch = "";
      for (var i=1; i<ctx.children.length; i++){
        tooMuch = tooMuch+getTooMuch(ctx.children[i]);
      }

      errorsToDisplay.push({line: currentLine, msg: "tooMuch"+tooMuch});

  }
};


// Visit a parse tree produced by LogoEditorParser#st.
LogoEditorVisitor.prototype.visitSt = function(ctx) {
  //MARTINA
  if (!(ctx.STMANYARGS == null)){
      // there are too many arguments for st

      errorsToDisplay.push({line: currentLine, msg: "stManyArgs"});

      //find out what is too much
      var tooMuch = "";
      for (var i=1; i<ctx.children.length; i++){
        tooMuch = tooMuch+getTooMuch(ctx.children[i]);
      }

      errorsToDisplay.push({line: currentLine, msg: "tooMuch"+tooMuch});

  }
};


// Visit a parse tree produced by LogoEditorParser#setpc.
LogoEditorVisitor.prototype.visitSetpc = function(ctx) {
  //MARTINA
  if (!(ctx.SETPCNOARG == null)){
    // there is no argument to setpc

    errorsToDisplay.push({line: currentLine, msg: "setpcNoArg"});

  } else if (!(ctx.SETPCMANYARGS == null)){
    // there are too many arguments to setpc

    errorsToDisplay.push({line: currentLine, msg: "setpcManyArgs"});

    //find out what is too much
      var tooMuch = "";
      for (var i=2; i<ctx.children.length; i++){
        tooMuch = tooMuch+getTooMuch(ctx.children[i]);
      }

      errorsToDisplay.push({line: currentLine, msg: "tooMuch"+tooMuch});

  }
  //MARTINA: visit expression
  // visit expression(s)
  for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9,8);
        if (text !== "Terminal") {
            visitChild(i, ctx, this);
        }
  }
};


// Visit a parse tree produced by LogoEditorParser#setsc.
LogoEditorVisitor.prototype.visitSetsc = function(ctx) {
  //MARTINA
  if (!(ctx.SETSCNOARG == null)){
    // there is no argument to setsc

    errorsToDisplay.push({line: currentLine, msg: "setscNoArg"});

  } else if (!(ctx.SETSCMANYARGS == null)){
    // there are too many arguments to setsc

    errorsToDisplay.push({line: currentLine, msg: "setscManyArgs"});

    //find out what is too much
      var tooMuch = "";
      for (var i=2; i<ctx.children.length; i++){
        tooMuch = tooMuch+getTooMuch(ctx.children[i]);
      }

      errorsToDisplay.push({line: currentLine, msg: "tooMuch"+tooMuch});

  }
  //MARTINA: visit expression
  // visit expression(s)
  for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9,8);
        if (text !== "Terminal") {
            visitChild(i, ctx, this);
        }
  }
};


// Visit a parse tree produced by LogoEditorParser#home.
LogoEditorVisitor.prototype.visitHome = function(ctx) {
  //MARTINA
  if (!(ctx.HOMEMANYARGS == null)){
    // there are arguments to home

    errorsToDisplay.push({line: currentLine, msg: "homeManyArgs"});

    //find out what is too much
      var tooMuch = "";
      for (var i=1; i<ctx.children.length; i++){
        tooMuch = tooMuch+getTooMuch(ctx.children[i]);
      }

      errorsToDisplay.push({line: currentLine, msg: "tooMuch"+tooMuch});

  }
};


// Visit a parse tree produced by LogoEditorParser#stop.
LogoEditorVisitor.prototype.visitStop = function(ctx) {
  //MARTINA
  if (!(ctx.STOPMANYARGS == null)){
    // there are arguments to stop

    errorsToDisplay.push({line: currentLine, msg: "stopManyArgs"});

    //find out what is too much
      var tooMuch = "";
      for (var i=1; i<ctx.children.length; i++){
        tooMuch = tooMuch+getTooMuch(ctx.children[i]);
      }

      errorsToDisplay.push({line: currentLine, msg: "tooMuch"+tooMuch});

  }
};


// Visit a parse tree produced by LogoEditorParser#setxy.
LogoEditorVisitor.prototype.visitSetxy = function(ctx) {
  //MARTINA
  if (!(ctx.SETXYNOARG == null)){
    // there is no arg to setxy

    errorsToDisplay.push({line: currentLine, msg: "setxyNoArg"});


  }else if (!(ctx.SETXYONEARG == null)){
    // there is only one arg to setxy

    errorsToDisplay.push({line: currentLine, msg: "setxyOneArg"});


  }else if (!(ctx.SETXYMANYARGS == null)){
    // there are too many args to setxy

    errorsToDisplay.push({line: currentLine, msg: "setxyManyArgs"});

    //find out what is too much
      var tooMuch = "";
      for (var i=3; i<ctx.children.length; i++){
        tooMuch = tooMuch+getTooMuch(ctx.children[i]);
      }

      errorsToDisplay.push({line: currentLine, msg: "tooMuch"+tooMuch});


  }
  //MARTINA: visit expression
  // visit expression(s)
  for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9,8);
        if (text !== "Terminal") {
            visitChild(i, ctx, this);
        }
  }
};


// Visit a parse tree produced by LogoEditorParser#setx.
LogoEditorVisitor.prototype.visitSetx = function(ctx) {

  //MARTINA
  if (!(ctx.SETXNOARG == null)){
    // there is no arg to setx

    errorsToDisplay.push({line: currentLine, msg: "setxNoArg"});

  }else if (!(ctx.SETXMANYARGS == null)){
    // there are too many args to setx

    errorsToDisplay.push({line: currentLine, msg: "setxManyArgs"});

    //find out what is too much
      var tooMuch = "";
      for (var i=2; i<ctx.children.length; i++){
        tooMuch = tooMuch+getTooMuch(ctx.children[i]);
      }

      errorsToDisplay.push({line: currentLine, msg: "tooMuch"+tooMuch});

  }
  //MARTINA: visit expression
  // visit expression(s)
  for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9,8);
        if (text !== "Terminal") {
            visitChild(i, ctx, this);
        }
  }
};


// Visit a parse tree produced by LogoEditorParser#sety.
LogoEditorVisitor.prototype.visitSety = function(ctx) {

  //MARTINA
  if (!(ctx.SETYNOARG == null)){
    // there is no arg to sety

    errorsToDisplay.push({line: currentLine, msg: "setyNoArg"});

  }else if (!(ctx.SETYMANYARGS == null)){
    // there are too many args to sety

    errorsToDisplay.push({line: currentLine, msg: "setyManyArgs"});

    //find out what is too much
      var tooMuch = "";
      for (var i=2; i<ctx.children.length; i++){
        tooMuch = tooMuch+getTooMuch(ctx.children[i]);
      }

      errorsToDisplay.push({line: currentLine, msg: "tooMuch"+tooMuch});

  }
  //MARTINA: visit expression
  // visit expression(s)
  for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9,8);
        if (text !== "Terminal") {
            visitChild(i, ctx, this);
        }
  }
};


// Visit a parse tree produced by LogoEditorParser#random.
LogoEditorVisitor.prototype.visitRandom = function(ctx) {
  //MARTINA
  if (!(ctx.RANDOMNOARG == null)){
    // there is no arg to random

    errorsToDisplay.push({line: currentLine, msg: "randomNoArg"});

  }else if (!(ctx.RANDOMMANYARGS == null)){
    // there are too many args to random

    errorsToDisplay.push({line: currentLine, msg: "randomManyArgs"});

    //find out what is too much
      var tooMuch = "";
      for (var i=2; i<ctx.children.length; i++){
        tooMuch = tooMuch+getTooMuch(ctx.children[i]);
      }

      errorsToDisplay.push({line: currentLine, msg: "tooMuch"+tooMuch});

  }
  //MARTINA: visit expression
  // visit expression(s)
  for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9,8);
        if (text !== "Terminal") {
            visitChild(i, ctx, this);
        }
  }
};


// Visit a parse tree produced by LogoEditorParser#sin.
LogoEditorVisitor.prototype.visitSin = function(ctx) {
  //MARTINA
  if (!(ctx.SINNOARG == null)){
    // there is no arg to sin

    errorsToDisplay.push({line: currentLine, msg: "sinNoArg"});

  }else if (!(ctx.SINMANYARGS == null)){
    // there are too many args to sin

    errorsToDisplay.push({line: currentLine, msg: "sinManyArgs"});

    //find out what is too much
      var tooMuch = "";
      for (var i=2; i<ctx.children.length; i++){
        tooMuch = tooMuch+getTooMuch(ctx.children[i]);
      }

      errorsToDisplay.push({line: currentLine, msg: "tooMuch"+tooMuch});

  }
  //MARTINA: visit expression
  // visit expression(s)
  for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9,8);
        if (text !== "Terminal") {
            visitChild(i, ctx, this);
        }
  }
};


// Visit a parse tree produced by LogoEditorParser#cos.
LogoEditorVisitor.prototype.visitCos = function(ctx) {
  //MARTINA
  if (!(ctx.COSNOARG == null)){
    // there is no arg to cos

    errorsToDisplay.push({line: currentLine, msg: "cosNoArg"});

  }else if (!(ctx.COSMANYARGS == null)){
    // there are too many args to cos

    errorsToDisplay.push({line: currentLine, msg: "cosManyArgs"});

    //find out what is too much
      var tooMuch = "";
      for (var i=2; i<ctx.children.length; i++){
        tooMuch = tooMuch+getTooMuch(ctx.children[i]);
      }

      errorsToDisplay.push({line: currentLine, msg: "tooMuch"+tooMuch});

  }
  //MARTINA: visit expression
  // visit expression(s)
  for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9,8);
        if (text !== "Terminal") {
            visitChild(i, ctx, this);
        }
  }
};


// Visit a parse tree produced by LogoEditorParser#tan.
LogoEditorVisitor.prototype.visitTan = function(ctx) {
  //MARTINA
  if (!(ctx.TANNOARG == null)){
    // there is no arg to tan

    errorsToDisplay.push({line: currentLine, msg: "tanNoArg"});

  }else if (!(ctx.TANMANYARGS == null)){
    // there are too many args to tan

    errorsToDisplay.push({line: currentLine, msg: "tanManyArgs"});

    //find out what is too much
      var tooMuch = "";
      for (var i=2; i<ctx.children.length; i++){
        tooMuch = tooMuch+getTooMuch(ctx.children[i]);
      }

      errorsToDisplay.push({line: currentLine, msg: "tooMuch"+tooMuch});

  }
  //MARTINA: visit expression
  // visit expression(s)
  for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9,8);
        if (text !== "Terminal") {
            visitChild(i, ctx, this);
        }
  }
};


// Visit a parse tree produced by LogoEditorParser#arcsin.
LogoEditorVisitor.prototype.visitArcsin = function(ctx) {
  //MARTINA
  if (!(ctx.ARCSINNOARG == null)){
    // there is no arg to arcsin

    errorsToDisplay.push({line: currentLine, msg: "arcsinNoArg"});

  }else if (!(ctx.ARCSINMANYARGS == null)){
    // there are too many args to arcsin

    errorsToDisplay.push({line: currentLine, msg: "arcsinManyArgs"});

    //find out what is too much
      var tooMuch = "";
      for (var i=2; i<ctx.children.length; i++){
        tooMuch = tooMuch+getTooMuch(ctx.children[i]);
      }

      errorsToDisplay.push({line: currentLine, msg: "tooMuch"+tooMuch});

  }
  //MARTINA: visit expression
  // visit expression(s)
  for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9,8);
        if (text !== "Terminal") {
            visitChild(i, ctx, this);
        }
  }
};


// Visit a parse tree produced by LogoEditorParser#arccos.
LogoEditorVisitor.prototype.visitArccos = function(ctx) {
  //MARTINA
  if (!(ctx.ARCCOSNOARG == null)){
    // there is no arg to arccos

    errorsToDisplay.push({line: currentLine, msg: "arccosNoArg"});

  }else if (!(ctx.ARCCOSMANYARGS == null)){
    // there are too many args to arccos

    errorsToDisplay.push({line: currentLine, msg: "arccosManyArgs"});

    //find out what is too much
      var tooMuch = "";
      for (var i=2; i<ctx.children.length; i++){
        tooMuch = tooMuch+getTooMuch(ctx.children[i]);
      }

      errorsToDisplay.push({line: currentLine, msg: "tooMuch"+tooMuch});

  }
  //MARTINA: visit expression
  // visit expression(s)
  for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9,8);
        if (text !== "Terminal") {
            visitChild(i, ctx, this);
        }
  }
};


// Visit a parse tree produced by LogoEditorParser#arctan.
LogoEditorVisitor.prototype.visitArctan = function(ctx) {
  //MARTINA
  if (!(ctx.ARCTANNOARG == null)){
    // there is no arg to arctan

    errorsToDisplay.push({line: currentLine, msg: "arctanNoArg"});

  }else if (!(ctx.ARCTANMANYARGS == null)){
    // there are too many args to arctan

    errorsToDisplay.push({line: currentLine, msg: "arctanManyArgs"});

    //find out what is too much
      var tooMuch = "";
      for (var i=2; i<ctx.children.length; i++){
        tooMuch = tooMuch+getTooMuch(ctx.children[i]);
      }

      errorsToDisplay.push({line: currentLine, msg: "tooMuch"+tooMuch});

  }
  //MARTINA: visit expression
  // visit expression(s)
  for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9,8);
        if (text !== "Terminal") {
            visitChild(i, ctx, this);
        }
  }
};


// Visit a parse tree produced by LogoEditorParser#abs.
LogoEditorVisitor.prototype.visitAbs = function(ctx) {
  //MARTINA
  if (!(ctx.ABSNOARG == null)){
    // there is no arg to abs

    errorsToDisplay.push({line: currentLine, msg: "absNoArg"});

  }else if (!(ctx.ABSMANYARGS == null)){
    // there are too many args to abs

    errorsToDisplay.push({line: currentLine, msg: "absManyArgs"});

    //find out what is too much
      var tooMuch = "";
      for (var i=2; i<ctx.children.length; i++){
        tooMuch = tooMuch+getTooMuch(ctx.children[i]);
      }

      errorsToDisplay.push({line: currentLine, msg: "tooMuch"+tooMuch});

  }
  //MARTINA: visit expression
  // visit expression(s)
  for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9,8);
        if (text !== "Terminal") {
            visitChild(i, ctx, this);
        }
  }
};


// Visit a parse tree produced by LogoEditorParser#sqrt.
LogoEditorVisitor.prototype.visitSqrt = function(ctx) {
  //MARTINA
  if (!(ctx.SQRTNOARG == null)){
    // there is no arg to sqrt

    errorsToDisplay.push({line: currentLine, msg: "sqrtNoArg"});

  }else if (!(ctx.SQRTMANYARGS == null)){
    // there are too many args to sqrt

    errorsToDisplay.push({line: currentLine, msg: "sqrtManyArgs"});

    //find out what is too much
      var tooMuch = "";
      for (var i=2; i<ctx.children.length; i++){
        tooMuch = tooMuch+getTooMuch(ctx.children[i]);
      }

      errorsToDisplay.push({line: currentLine, msg: "tooMuch"+tooMuch});

  }
  //MARTINA: visit expression
  // visit expression(s)
  for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9,8);
        if (text !== "Terminal") {
            visitChild(i, ctx, this);
        }
  }
};


// Visit a parse tree produced by LogoEditorParser#mod.
LogoEditorVisitor.prototype.visitMod = function(ctx) {

  //MARTINA
  if (!(ctx.MODNOARG == null)){
    // there is no argument to mod

    errorsToDisplay.push({line: currentLine, msg: "modNoArg"});


  }else if (!(ctx.MODONEARG == null)){
    // there is only one argument to mod

    errorsToDisplay.push({line: currentLine, msg: "modOneArg"});


  }else if (!(ctx.MODMANYARGS == null)){
    // there are too many arguments to mod

    errorsToDisplay.push({line: currentLine, msg: "modManyArgs"});

    //find out what is too much
      var tooMuch = "";
      for (var i=3; i<ctx.children.length; i++){
        tooMuch = tooMuch+getTooMuch(ctx.children[i]);
      }

      errorsToDisplay.push({line: currentLine, msg: "tooMuch"+tooMuch});


  }
  //MARTINA: visit expression
  // visit expression(s)
  for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9,8);
        if (text !== "Terminal") {
            visitChild(i, ctx, this);
        }
  }
};


// Visit a parse tree produced by LogoEditorParser#power.
LogoEditorVisitor.prototype.visitPower = function(ctx) {

  //MARTINA
  if (!(ctx.POWERNOARG == null)){
    // there is no argument to power

    errorsToDisplay.push({line: currentLine, msg: "powerNoArg"});


  }else if (!(ctx.POWERONEARG == null)){
    // there is only one argument to power

    errorsToDisplay.push({line: currentLine, msg: "powerOneArg"});


  }else if (!(ctx.POWERMANYARGS == null)){
    // there are too many arguments to mod

    errorsToDisplay.push({line: currentLine, msg: "powerManyArgs"});

    //find out what is too much
      var tooMuch = "";
      for (var i=3; i<ctx.children.length; i++){
        tooMuch = tooMuch+getTooMuch(ctx.children[i]);
      }

      errorsToDisplay.push({line: currentLine, msg: "tooMuch"+tooMuch});

  }
  //MARTINA: visit expression
  // visit expression(s)
  for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9,8);
        if (text !== "Terminal") {
            visitChild(i, ctx, this);
        }
  }
};


// Visit a parse tree produced by LogoEditorParser#log10.
LogoEditorVisitor.prototype.visitLog10 = function(ctx) {

  //MARTINA
  if (!(ctx.LOGNOARG == null)){
    // there is no arg to log

    errorsToDisplay.push({line: currentLine, msg: "logNoArg"});

  }else if (!(ctx.LOGMANYARGS == null)){
    // there are too many args to log

    errorsToDisplay.push({line: currentLine, msg: "logManyArgs"});

    //find out what is too much
      var tooMuch = "";
      for (var i=2; i<ctx.children.length; i++){
        tooMuch = tooMuch+getTooMuch(ctx.children[i]);
      }

      errorsToDisplay.push({line: currentLine, msg: "tooMuch"+tooMuch});

  }
  //MARTINA: visit expression
  // visit expression(s)
  for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9,8);
        if (text !== "Terminal") {
            visitChild(i, ctx, this);
        }
  }
};


// Visit a parse tree produced by LogoEditorParser#waite.
LogoEditorVisitor.prototype.visitWaite = function(ctx) {
  //MARTINA
  if (!(ctx.WAITNOARG == null)){
    // there is no arg to wait

    errorsToDisplay.push({line: currentLine, msg: "waitNoArg"});

  }else if (!(ctx.WAITMANYARGS == null)){
    // there are too many args to wait

    errorsToDisplay.push({line: currentLine, msg: "waitManyArgs"});

    //find out what is too much
      var tooMuch = "";
      for (var i=2; i<ctx.children.length; i++){
        tooMuch = tooMuch+getTooMuch(ctx.children[i]);
      }

      errorsToDisplay.push({line: currentLine, msg: "tooMuch"+tooMuch});

  }
  //MARTINA: visit expression
  // visit expression(s)
  for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9,8);
        if (text !== "Terminal") {
            visitChild(i, ctx, this);
        }
  }
};


// Visit a parse tree produced by LogoEditorParser#wash.
LogoEditorVisitor.prototype.visitWash = function(ctx) {
  //MARTINA
  if (!(ctx.WASHMANYARGS == null)){
    // there are too many arguments to wash

    errorsToDisplay.push({line: currentLine, msg: "washManyArgs"});

    //find out what is too much
      var tooMuch = "";
      for (var i=1; i<ctx.children.length; i++){
        tooMuch = tooMuch+getTooMuch(ctx.children[i]);
      }

      errorsToDisplay.push({line: currentLine, msg: "tooMuch"+tooMuch});

  }
};


// Visit a parse tree produced by LogoEditorParser#setpw.
LogoEditorVisitor.prototype.visitSetpw = function(ctx) {
  //MARTINA
  if (!(ctx.SETPWNOARG == null)){
    // there is no arg to setpw

    errorsToDisplay.push({line: currentLine, msg: "setpwNoArg"});

  }else if (!(ctx.SETPWMANYARGS == null)){
    // there are too many args to setpw

    errorsToDisplay.push({line: currentLine, msg: "setpwManyArgs"});

    //find out what is too much
      var tooMuch = "";
      for (var i=2; i<ctx.children.length; i++){
        tooMuch = tooMuch+getTooMuch(ctx.children[i]);
      }

      errorsToDisplay.push({line: currentLine, msg: "tooMuch"+tooMuch});

  }
  //MARTINA: visit expression
  // visit expression(s)
  for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9,8);
        if (text !== "Terminal") {
            visitChild(i, ctx, this);
        }
  }
};


// Visit a parse tree produced by LogoEditorParser#circle.
LogoEditorVisitor.prototype.visitCircle = function(ctx) {
  //MARTINA
  if (!(ctx.CIRCLENOARG == null)){
    // there is no arg to circle

    errorsToDisplay.push({line: currentLine, msg: "circleNoArg"});

  }else if (!(ctx.CIRCLEMANYARGS == null)){
    // there are too many args to circle

    errorsToDisplay.push({line: currentLine, msg: "circleManyArgs"});

    //find out what is too much
      var tooMuch = "";
      for (var i=2; i<ctx.children.length; i++){
        tooMuch = tooMuch+getTooMuch(ctx.children[i]);
      }

      errorsToDisplay.push({line: currentLine, msg: "tooMuch"+tooMuch});

  }
  //MARTINA: visit expression
  // visit expression(s)
  for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9,8);
        if (text !== "Terminal") {
            visitChild(i, ctx, this);
        }
  }
};


// Visit a parse tree produced by LogoEditorParser#setheading.
LogoEditorVisitor.prototype.visitSetheading = function(ctx) {
  //MARTINA
  if (!(ctx.SETHEADINGNOARG == null)){
    // there is no arg to setheading

    errorsToDisplay.push({line: currentLine, msg: "setheadingNoArg"});

  }else if (!(ctx.SETHEADINGMANYARGS == null)){
    // there are too many args to setheading

    errorsToDisplay.push({line: currentLine, msg: "setheadingManyArgs"});

    //find out what is too much
      var tooMuch = "";
      for (var i=2; i<ctx.children.length; i++){
        tooMuch = tooMuch+getTooMuch(ctx.children[i]);
      }

      errorsToDisplay.push({line: currentLine, msg: "tooMuch"+tooMuch});

  }
  //MARTINA: visit expression
  // visit expression(s)
  for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9,8);
        if (text !== "Terminal") {
            visitChild(i, ctx, this);
        }
  }
};


// Visit a parse tree produced by LogoEditorParser#number.
LogoEditorVisitor.prototype.visitNumber = function(ctx) {
};


// Visit a parse tree produced by LogoEditorParser#comment.
LogoEditorVisitor.prototype.visitComment = function(ctx) {
};


// Visit a parse tree produced by LogoEditorParser#pie.
LogoEditorVisitor.prototype.visitPie = function(ctx) {
};


// Visit a parse tree produced by LogoEditorParser#ee.
LogoEditorVisitor.prototype.visitEe = function(ctx) {
};

//MARTINA
LogoEditorVisitor.prototype.visitEol = function(ctx) {
  currentLine = currentLine + 1;
};

//MARTINA
LogoEditorVisitor.prototype.visitColorname = function(ctx) {
  if (!(ctx.COLORNAMENOTOK == null)){

    //weirdName: what did they write instead of the colorname
    var weirdName = ctx.children[0].getText();

    //check if there is a parameter with this name
      if (parameterNames.indexOf(weirdName) !== -1 || methodVariables[name].indexOf(weirdName) !== -1){
        //errorsToDisplay.push({line: currentLine, msg: "noColorWithThisName"});
        errorsToDisplay.push({line: currentLine, msg: "noColorWithThisName"+weirdName});
        errorsToDisplay.push({line: currentLine, msg: "didYouMean"+":"+weirdName});
        return;
      }

    //MARTINA: check for similarities to a colorname
    var colorArray = ['black','red','green','yellow','blue','magenta','cyan','white','gray','lightgray','darkred','darkgreen','darkblue','orange','pink','purple','brown'];
    var similarColor;
    var longer;
    var shorter;
    for (let color of colorArray){
      if (weirdName.length > color.length){
        longer = weirdName;
        shorter = color;
      }else{
        longer = color;
        shorter = weirdName;
      }

      //calculate damerau levenshtein distance
      var damerauLevenshtein = damlev(longer,shorter);

      if (damerauLevenshtein<=color.length/2){
        similarColor = color;
      }
    }
    if (similarColor == null){
      // there was no similar colorname found

      errorsToDisplay.push({line: currentLine, msg: "noColorWithThisName"+weirdName});

    }else{
      // there was a similar colorname found

      errorsToDisplay.push({line: currentLine, msg: "colornameMisspelled"+similarColor});

    }
  }
}

//MARTINA
LogoEditorVisitor.prototype.visitRgb = function(ctx) {
  if (!(ctx.RGBMISSINGLEFTBR == null)){
    // the left bracket is missing

    errorsToDisplay.push({line: currentLine, msg: "rgbMissingLeftBr"});

  }else if (!(ctx.RGBMISSINGRIGHTBR == null)){
    // the right bracket is missing

    errorsToDisplay.push({line: currentLine, msg: "rgbMissingRightBr"});

  }else if (!(ctx.RGBMISSINGVALUES == null)){
    // there are not enough values in the brackets

    errorsToDisplay.push({line: currentLine, msg: "rgbMissingValues"});

  }else if (!(ctx.RGBWRONGPARENTHESES == null)){
    // used () instead of []

    errorsToDisplay.push({line: currentLine, msg: "rgbWrongParentheses"});

  }else if (!(ctx.RGBCOMMAS == null)){
    // there are commas between the values

    errorsToDisplay.push({line: currentLine, msg: "rgbCommas"});

  }else if (!(ctx.RGBWRONGRIGHTBR == null)){
    // the right bracket is ! or )

    errorsToDisplay.push({line: currentLine, msg: "rgbWrongRightBr"});

  }


  //MARTINA: visit the 3 expressions
  for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9,8);
        if (text !== "Terminal") {
            visitChild(i, ctx, this);
        }
  }
}

//MARTINA
LogoEditorVisitor.prototype.visitBlock = function(ctx) {
  if (!(ctx.BLOCKWRONGBRACKETS == null)){
    // used () instead of []

    errorsToDisplay.push({line: currentLine, msg: "blockWrongBrackets"});

  }else if (!(ctx.BLOCKMISSINGRIGHTBR == null)){
    // forgot right bracket

    errorsToDisplay.push({line: currentLine, msg: "blockMissingRightBr"});

  }else if (!(ctx.BLOCKMISSINGLEFTBR == null)){
    // forgot left bracket

    errorsToDisplay.push({line: currentLine, msg: "blockMissingLeftBr"});

  }else if (!(ctx.BLOCKWRONGRIGHTBR == null)){
    // the right bracket is ! or )

    errorsToDisplay.push({line: currentLine, msg: "blockWrongRightBr"});

  }

  //MARTINA TODO: visit commands inside block
  for (var i = 0; i < ctx.children.length; i++) {
        var text = ctx.children[i].constructor.toString().substr(9,8);
        if (text !== "Terminal") {
            visitChild(i, ctx, this);
        }
  }
}


//MARTINA
LogoEditorVisitor.prototype.visitMaybeTo = function(ctx) {
    // maybe 'to' was misspelled
    var maybeTo = ctx.getText();
    var longer;
    var shorter;
    if (maybeTo.length>2){
      longer = maybeTo;
      shorter = "to";
    }else{
      longer = "to";
      shorter = maybeTo;
    }
    //calculate damerau-levenshtein distance
    var damerauLevenshtein = damlev(longer,shorter);

    if (damerauLevenshtein<2){

      errorsToDisplay.push({line: currentLine, msg: "maybeTo"});

    }else{

      errorsToDisplay.push({line: currentLine, msg: "missingTo"});

    }
}

//MARTINA
LogoEditorVisitor.prototype.visitEnd = function(ctx) {
  // if the name of the function is not 'end'
  if (!nameEnd){
    // check for manyEnds
    if (!(end[name]===0)){
      errorsToDisplay.push({line: currentLine, msg: "manyEnds"});
    }
    end[name] = end[name]+1;
  }else{
    if (end[name]>1){
      errorsToDisplay.push({line: currentLine, msg: "manyEnds"});
    }
    end[name] = end[name]+1;
  }
}

exports.LogoEditorVisitor = LogoEditorVisitor;


//////////////////
// WEBPACK FOOTER
// ./src/app/interpreter/interpreter-editor/LogoEditorVisitor.js
// module id = ./src/app/interpreter/interpreter-editor/LogoEditorVisitor.js
// module chunks = main